import React from 'react';
import { twMerge } from 'tailwind-merge';
import classNames from 'classnames';

function ButtonPrimary({
  children,
  onClick,
  disabled = false,
  className,
  id,
  type = 'button',
}) {
  return (
    <button
      className={twMerge(
        classNames(
          'flex h-[55px] items-center shadow-md rounded disabled:bg-aw-gray-200 disabled:text-aw-midnight',
          'bg-primary-cta py-2 px-3 font-aw-sans font-bold text-primary-cta-text lg:py-4 lg:px-6',
          'hover:bg-primary-cta-text hover:text-primary-cta hover:border-primary-cta-text'
        ),
        className
      )}
      onClick={onClick}
      disabled={disabled}
      type={type}
      id={id}
    >
      {children}
    </button>
  );
}

export default ButtonPrimary;
